export const multiVaultAbi = [
    {
        inputs: [
            {
                internalType: 'address',
                name: '_NATIVE',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_uniLikeRouterAddress',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_withdrawer',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_pair',
                type: 'address',
            },
            {
                internalType: 'address[]',
                name: '_proxyReceivers',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: '_base',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_quote',
                type: 'address',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'criticalBase',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'criticalQuote',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct MultiVault.Critical',
                name: '_critical',
                type: 'tuple',
            },
            {
                internalType: 'uint128',
                name: '_feeNumerator',
                type: 'uint128',
            },
            {
                internalType: 'uint128',
                name: '_feeDenominator',
                type: 'uint128',
            },
            {
                internalType: 'address[]',
                name: '_executors',
                type: 'address[]',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'newExecutors',
                type: 'address[]',
            },
        ],
        name: 'addExecutors',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'newProxyReceivers',
                type: 'address[]',
            },
        ],
        name: 'addProxyReceivers',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amountInMax',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amountOut',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'vault',
                type: 'address',
            },
        ],
        name: 'buyFromApprovedAddress',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amountInMax',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amountOut',
                type: 'uint256',
            },
        ],
        name: 'buyUndecodable',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'toCheck',
                type: 'address',
            },
        ],
        name: 'isExecutor',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'contractToCall',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: 'callData',
                type: 'bytes',
            },
        ],
        name: 'makeEmergencyCall',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'removedExecutors',
                type: 'address[]',
            },
        ],
        name: 'removeExecutors',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'removeProxyReceivers',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amountIn',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amountOutMin',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'vault',
                type: 'address',
            },
        ],
        name: 'sellFromApprovedAddress',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amountIn',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amountOutMin',
                type: 'uint256',
            },
        ],
        name: 'sellUndecodable',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_criticalBase',
                type: 'uint256',
            },
        ],
        name: 'setCriticalBase',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_criticalQuote',
                type: 'uint256',
            },
        ],
        name: 'setCriticalQuote',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amountIn',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amountOutMin',
                type: 'uint256',
            },
            {
                internalType: 'address[]',
                name: '__',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: 'vault',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'deadline',
                type: 'uint256',
            },
        ],
        name: 'swapExactTokensForTokens',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amountInMax',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amountOut',
                type: 'uint256',
            },
            {
                internalType: 'address[]',
                name: '__',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: 'vault',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'deadline',
                type: 'uint256',
            },
        ],
        name: 'swapTokensForExactTokens',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'receiver',
                type: 'address',
            },
        ],
        name: 'withdrawETH',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'tokenAddress',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'receiver',
                type: 'address',
            },
        ],
        name: 'withdrawTokens',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
